import { createFileRoute } from "@tanstack/react-router";
import { BULK_CSV_CHECKER_FAQS } from "@/components/marketing/bulk-csv-checker-faqs";
import { BulkCsvCheckerTool } from "@/components/marketing/bulk-csv-checker-tool";
import { toolPageHead } from "@/lib/seo";

/**
 * `head` is never code-split, so the FAQs live in their own module rather than
 * being imported from the tool component. See `tools.thread-splitter.tsx`.
 */
export const Route = createFileRoute("/(public)/tools/bulk-csv-checker")({
  head: () => toolPageHead("bulkCsvChecker", BULK_CSV_CHECKER_FAQS),
  component: BulkCsvCheckerTool,
});
